import React, { Component } from 'react';
import { connect } from 'react-redux'
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import './style.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { verifyAuthToken } from '../state/user/actions'
import { Login } from './common/login';
import { Dashboard } from './dashboard';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Backdrop } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { green, purple } from '@mui/material/colors';
import {useState, useEffect, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    useHistory
} from "react-router-dom";

const theme = createTheme({
    components: {
        MuiTypography: {
          defaultProps: {
            variantMapping: {
              heading: 'h2',
              subHead: 'h5',
              paraPrimary: 'p'
            },
          },
        },
        MuiButton: {
            variants: [
                {
                    props: { variant: 'contained-s-p' },
                    style: {
                      paddingLeft: '2.5em',
                      paddingRight: '2.5em',
                      background: '#274073'
                    },
                  },
            ]
        }
      },
    typography: {
        heading: {
            color: '#274073',
            fontWeight: 'bold'
        },
        subHead: {
            color: '#274073',
        },
        paraPrimary: {
            color: '#274073',
        }
    },
    palette: {
        primary: {
            main: '#274073',
            light: '#42a5f5',
            dark: '#1565c0',
            contrastText: '#fff',
        },
        secondary: {
            main: green[500],
        },
    },
});

const Theme = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { user,requestingCheckAuth} = useSelector((state) => (state.user || {}))
    const previousRequestingCheckAuth = useRef(null)

    useEffect(()=> {
        dispatch(verifyAuthToken())
    },[])
    useEffect(()=> {
        if(!user && !requestingCheckAuth && previousRequestingCheckAuth.current ) {
            history.push('/login')
        }
        previousRequestingCheckAuth.current = requestingCheckAuth
    }, [requestingCheckAuth])

    useEffect(()=>{
        
    })

    return (
        <ThemeProvider theme={theme}>
            {
                requestingCheckAuth &&
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={true}
                    
                    >
                    <CircularProgress color="inherit" />
                    </Backdrop>
            }
            {
                requestingCheckAuth === false&&
              
                    <Switch>
                        <Route path="/login" component={Login}></Route>
                        <Route path="/" component={Dashboard}></Route>
                    </Switch>
                
            }
            
        </ThemeProvider>

    )
}


export default connect(
    state => {
        return {
            user: state.user || {},
        }
    },
    {
        verifyAuthToken
    }
)(Theme)